var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCommentWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gumb-App-(MVP)",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "Additional-actions_owner_MVP-2_desktop",
    transform: "translate(-1321.000000, -855.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(1064.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(0.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Form/Button-Copy",
    transform: "translate(226.000000, 844.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.499975,3 C42.3273122,3 42.9999714,3.67265922 42.9999714,4.49999642 L42.9999714,11.2499803 C42.9999714,12.0773175 42.3273122,12.7499768 41.499975,12.7499768 L38.124983,12.7499768 L35.1976371,14.9460698 C35.012495,15.0820024 34.7499911,14.9484044 34.7499911,14.7187221 L34.7499911,12.7499768 L32.4999964,12.7499768 C31.6726592,12.7499768 31,12.0773175 31,11.2499803 L31,4.5 C31,3.67265922 31.6726592,3 32.5,3 L41.499975,3 Z M37.7499839,9.18748525 L37.7499839,8.81248614 C37.7499839,8.70935223 37.6656183,8.62498659 37.5624844,8.62498659 L34.1874924,8.62498659 C34.0843585,8.62498659 33.9999928,8.70935223 33.9999928,8.81248614 L33.9999928,9.18748525 C33.9999928,9.29061916 34.0843585,9.3749848 34.1874924,9.3749848 L37.5624844,9.3749848 C37.6656183,9.3749848 37.7499839,9.29061916 37.7499839,9.18748525 Z M39.9999785,6.93749061 L39.9999785,6.56249151 C39.9999785,6.4593576 39.9156129,6.37499195 39.812479,6.37499195 L34.1874924,6.37499195 C34.0843585,6.37499195 33.9999928,6.4593576 33.9999928,6.56249151 L33.9999928,6.93749061 C33.9999928,7.04062452 34.0843585,7.12499017 34.1874924,7.12499017 L39.812479,7.12499017 C39.9156129,7.12499017 39.9999785,7.04062452 39.9999785,6.93749061 Z",
    id: "\\uF4A6"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentWhite);
export default __webpack_public_path__ + "static/media/comment-white.389caf85.svg";
export { ForwardRef as ReactComponent };